import { Block } from "modules/Block";

export class GatedDownloadBlock extends Block<typeof GatedDownloadBlock> {
    static readonly className: string = "js-gated-download-block";

    // keep our own reference to the root for this block instance
    private handled = false;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);
        this.init(); // MUST call init here
    }

    init(): void {
        // the outer wrapper for this gated download instance
        const wrapper = this.rootElement.closest(".gated-download-block__wrapper");
        if (!wrapper) return;

        const downloadLink = wrapper.querySelector<HTMLAnchorElement>(".download__link");
        const introText = wrapper.querySelector<HTMLElement>(".intro");
        const newsletterForm = wrapper.querySelector<HTMLElement>(".newsletter-form");
        const successState = wrapper.querySelector<HTMLElement>(".gated-download-success");

        if (!this.rootElement || !downloadLink || !successState) return;

        const fileUrl = this.rootElement.dataset.downloadUrl;

        if (!fileUrl) return;

        // The specific form DOM under THIS block (scope the handler)
        const localForm = this.rootElement.querySelector(".EPiServerForms");

        this.waitForEpiforms(() => {
            const epi = window.$$epiforms!;

            // If we found a local form under this block, attach to that only;
            // otherwise, attach to all forms but filter inside the handler.
            const $target = localForm ? epi(localForm) : epi(".EPiServerForms");

            $target.on("formsSubmitted", (evt: EpiFormsSubmittedEvent) => {
                if (this.handled) return;

                // If multiple forms exist, ensure the event belongs to this block's form.
                // evt.currentTarget is the form element raising the event.
                if (localForm && evt?.currentTarget !== localForm) return;
                if (evt?.isSuccess !== true) return;

                this.handled = true;

                if (introText) { introText.style.display = "none"; }
                if (newsletterForm) { newsletterForm.style.display = "none"; }
                successState.hidden = false;

                // Optional: Also trigger download automatically (but show link as backup)
                //this.triggerDownload(fileUrl);
            });
        });
    }

    private waitForEpiforms(done: () => void) {
        const check = () => {
            if (window.$$epiforms) return done();
            setTimeout(check, 100);
        };
        check();
    }
}